export default __webpack_public_path__ + "static/media/iconfont.9ad554c8.woff2";